import { BoardFilterSetData } from './board-v3.types';

export function normalizeBoardFilterData(data?: BoardFilterSetData | null): BoardFilterSetData {
  return {
    version: 1,
    mode: data?.mode === 'OR' ? 'OR' : 'AND',
    conditions: Array.isArray(data?.conditions) ? data.conditions : [],
    view: { is_view_success: false, is_view_failed: false, ...data?.view },
  };
}
